/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceDraft } from "./SpaceDraft";
export const SpaceDraftListResponse = core.serialization.object({
    data: core.serialization.list(SpaceDraft),
});
